import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "contact-container" }
const _hoisted_2 = {
  key: 0,
  class: "toast"
}
const _hoisted_3 = {
  key: 1,
  class: "confirm-toast-overlay"
}
const _hoisted_4 = { class: "card-contact" }
const _hoisted_5 = { class: "checkbox-label" }

import {ref} from 'vue'
import '@/assets/styles/contact.css'
import axios from 'axios'


export default /*@__PURE__*/_defineComponent({
  __name: 'ContactView',
  setup(__props) {

const name = ref('')
const email = ref('')
const message = ref('')
const submitted = ref(false)
const error = ref('')
const showToast = ref(false);
const toastMessage = ref("");
const showConfirmToast = ref(false);

const form = ref({
  name: '',
  email: '',
  message: '',
  data: false
})

const submitForm = async () => {

  submitted.value = false
  error.value = ''

  try {
    const res = await axios.post("/api/contact", {
      name: form.value.name,
      email: form.value.email,
      message: form.value.message
    })
    submitted.value = true
    form.value = {name: "", email: "", message: "", data: false}

    console.log("Antwort: ", res.data);
  } catch (err) {
    error.value = 'Fehler beim Versenden';
    console.error(err);
  }
};

const abfrage = () => {
  showConfirmToast.value = true;
}

const confirmSubmission = async () => {
  submitForm();

  toastMessage.value = "Ihre Kontaktanfrage wurde übermittelt.";
  showToast.value = true;

  setTimeout(() => showToast.value = false, 4000);
  showConfirmToast.value = false;
}

const cancelSubmission = async () => {
  showConfirmToast.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showToast.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(toastMessage.value), 1))
      : _createCommentVNode("", true),
    (showConfirmToast.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", { class: "confirm-toast-box" }, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "confirm-icon" }, "K", -1)),
            _cache[5] || (_cache[5] = _createElementVNode("p", { class: "confirm-eyebrow" }, "Kontaktanfrage senden", -1)),
            _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Anfrage abschicken?", -1)),
            _cache[7] || (_cache[7] = _createElementVNode("p", { class: "confirm-copy" }, " Ihre Nachricht wird an KFZ Musterwerkstatt übermittelt. Wir melden uns schnellstmöglich bei Ihnen zurück. ", -1)),
            _createElementVNode("div", { class: "confirm-toast-buttons" }, [
              _createElementVNode("button", {
                class: "cancel-btn",
                type: "button",
                onClick: cancelSubmission
              }, "Abbrechen"),
              _createElementVNode("button", {
                class: "confirm-btn",
                type: "button",
                onClick: confirmSubmission
              }, "Anfrage senden")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _cache[14] || (_cache[14] = _createElementVNode("h1", null, "Kontakt", -1)),
      _cache[15] || (_cache[15] = _createElementVNode("p", null, "Schreiben Sie uns direkt. Wir melden uns schnellstmöglich mit einer persönlichen Rückmeldung.", -1)),
      _createElementVNode("form", {
        onSubmit: _withModifiers(abfrage, ["prevent"]),
        class: "contact-form"
      }, [
        _createElementVNode("label", null, [
          _cache[8] || (_cache[8] = _createTextVNode(" Name: ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
            placeholder: "Dein Name",
            required: ""
          }, null, 512), [
            [_vModelText, form.value.name]
          ])
        ]),
        _createElementVNode("label", null, [
          _cache[9] || (_cache[9] = _createTextVNode(" E-Mail: ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "email",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.email) = $event)),
            placeholder: "Deine E-Mail",
            required: ""
          }, null, 512), [
            [_vModelText, form.value.email]
          ])
        ]),
        _createElementVNode("label", null, [
          _cache[10] || (_cache[10] = _createTextVNode(" Nachricht: ", -1)),
          _withDirectives(_createElementVNode("textarea", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.message) = $event)),
            placeholder: "Deine Nachricht",
            required: ""
          }, null, 512), [
            [_vModelText, form.value.message]
          ])
        ]),
        _createElementVNode("label", _hoisted_5, [
          _cache[11] || (_cache[11] = _createElementVNode("span", { class: "checkbox-text" }, [
            _createTextVNode(" Ich stimme der Verarbeitung meiner Daten gemäß "),
            _createElementVNode("a", {
              href: "/datenschutz",
              target: "_blank"
            }, "Datenschutzerklärung"),
            _createTextVNode(" zu. ")
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "checkbox",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.data) = $event)),
            required: ""
          }, null, 512), [
            [_vModelCheckbox, form.value.data]
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("span", { class: "custom-checkbox" }, null, -1))
        ]),
        _cache[13] || (_cache[13] = _createElementVNode("button", { type: "submit" }, "Absenden", -1))
      ], 32)
    ])
  ]))
}
}

})